import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApplicationStore } from '../../shared/state/store/index';
import { Store } from '@ngrx/store';

@Component({
	selector: 'app-loading',
	templateUrl: './loading.component.html',
	styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
	globalLoading: boolean = false;
	storeSubscription = new Subscription();

	constructor(private store: Store<ApplicationStore>) {
		this.storeSubscription = this.store.select('global').subscribe(state => {
			this.globalLoading = state.loading;
		});
	}

}
